import { createElement } from 'react';
import classNames from 'classnames';
const classPrefix = `au-dragbar`;
const Ticks = ({ points, max, min, value, }) => {
    const range = max - min;
    const elements = points.map(point => {
        const offset = `${(Math.abs(point - min) / range) * 100}%`;
        const isActived = point <= value;
        const style = { left: offset };
        const pointClassName = classNames({
            [`${classPrefix}-tick`]: true,
            [`${classPrefix}-tick-active`]: isActived,
        });
        return createElement("span", { className: pointClassName, style: style, key: point });
    });
    return createElement("div", { className: `${classPrefix}-ticks` }, elements);
};
export default Ticks;
